import React from 'react';
import './Button.css';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'success' | 'warning' | 'error' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  loading?: boolean;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  fullWidth?: boolean;
}

export const Button: React.FC<ButtonProps> = ({
  children,
  variant = 'primary',
  size = 'md',
  loading = false,
  leftIcon,
  rightIcon,
  fullWidth = false,
  className = '',
  disabled,
  ...props
}) => {
  const baseClass = 'button';
  const classes = [
    baseClass,
    `${baseClass}--${variant}`,
    `${baseClass}--${size}`,
    fullWidth && `${baseClass}--full-width`,
    loading && `${baseClass}--loading`,
    className
  ].filter(Boolean).join(' ');

  return (
    <button
      className={classes}
      disabled={disabled || loading}
      aria-disabled={disabled || loading}
      {...props}
    >
      {loading && (
        <span className={`${baseClass}__spinner`} aria-hidden="true">
          <svg viewBox="0 0 24 24" className={`${baseClass}__spinner-icon`}>
            <circle
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
              fill="none"
              strokeLinecap="round"
              strokeDasharray="32"
              strokeDashoffset="32"
            />
          </svg>
        </span>
      )}
      {!loading && leftIcon && (
        <span className={`${baseClass}__icon ${baseClass}__icon--left`} aria-hidden="true">
          {leftIcon}
        </span>
      )}
      <span className={`${baseClass}__content`}>
        {children}
      </span>
      {!loading && rightIcon && (
        <span className={`${baseClass}__icon ${baseClass}__icon--right`} aria-hidden="true">
          {rightIcon}
        </span>
      )}
    </button>
  );
};

export default Button;